import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

type Props = {};

const Home = (props: Props) => {
  const navigate = useNavigate();

  useEffect(() => {
    
  }, []);

  return (
    <div className="flex flex-col items-center justify-center p-4 h-screen w-screen z-0">
      {/* <h1 className={`text-center text-3xl font-extrabold my-4`}>Phonics World</h1> */}

        <motion.img
          src="/Others/logo.png"
          alt="Logo"
          className={`w-[80%] lg:w-1/3 z-10`}
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity:  1 , scale:  1  }}
          transition={{ duration: 0.5 }}
        />
    
      <motion.div
        className={`flex flex-col gap-4`}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
      >
        <motion.div
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          onClick={() => navigate("/nowyousay")}
          className="btn btn-wide text-white glass hover:bg-green-400 hover:text-white z-20"
        >
          Now You Say
        </motion.div>
        <motion.div
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          onClick={() => navigate("/isfor")}
          className="btn btn-wide text-white glass hover:bg-green-400 hover:text-white z-20"
        >
          Is For
        </motion.div>
        <motion.div
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          onClick={() => navigate("/tracealetter")}
          className="btn btn-wide text-white glass hover:bg-green-400 hover:text-white z-20"
        >
          Trace a word
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Home;
